import React from 'react';
import { Container } from '@src/components/Container';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import PaymentMethods from '../PaymentMethods';
import BillingHistory from '../BillingHistory';
import './styles.scss';

export default function PaymentBilling() {
  return (
    <Container className="payment-billing" type={ContainerType.BORDERED}>
      <PaymentMethods />
      <BillingHistory />
    </Container>
  );
}
